// Implements: F-UIX-019, F-GEN-022, F-RPT-006
/**
 * Mockup v3 P9 (default P4-4): the "Qué hace" sentence of each generation flow and the Spanish
 * word of each step role, from the frontend dictionary (`GET /flows` names neither). A flow or a
 * role the dictionary does not know reads as its raw text: never a blank cell, never a crash, and
 * an inherited property name ("constructor") is not a known entry.
 */

import { t } from "../../../shared/i18n";

/** Read at call time, so the words follow the dictionary in force. */
function what(): Readonly<Record<string, string>> {
  return {
    prototype: t("admin.flows.what.prototype"),
    update: t("admin.flows.what.update"),
    prototype_from_brief: t("admin.flows.what.prototypeFromBrief"),
    assess: t("admin.flows.what.assess"),
    summarize: t("admin.flows.what.summarize"),
    diagram: t("admin.flows.what.diagram"),
    diagram_walkthrough: t("admin.flows.what.diagramWalkthrough"),
    brief: t("admin.flows.what.brief"),
  };
}

function roles(): Readonly<Record<string, string>> {
  return {
    normalize: t("admin.flows.role.normalize"),
    assess: t("admin.flows.role.assess"),
    desktop: t("admin.flows.role.desktop"),
    mobile: t("admin.flows.role.mobile"),
    summarize: t("admin.flows.role.summarize"),
    diagram: t("admin.flows.role.diagram"),
    name: t("admin.flows.role.name"),
  };
}

function known(table: Readonly<Record<string, string>>, id: string): string {
  const text = Object.hasOwn(table, id) ? table[id] : undefined;
  return text ?? id;
}

export function flowWhatText(flowId: string): string {
  return known(what(), flowId);
}

export function stepRoleText(role: string): string {
  return known(roles(), role);
}
